<template>
  <div class="config-container">
    <el-card>
      <template #header>
        <span>配置管理</span>
      </template>
      
      <el-tabs v-model="activeTab">
        <el-tab-pane label="服务数据" name="strength">
          <el-table :data="strengthData" border style="width: 100%">
            <el-table-column prop="key" label="配置项" width="180"></el-table-column>
            <el-table-column prop="value" label="数值"></el-table-column>
            <el-table-column label="操作" width="150">
              <template #default="scope">
                <el-button type="text" @click="handleEdit(scope.row)">编辑</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="轮播图管理" name="banner">
          <el-card style="margin-bottom: 20px;">
            <div style="font-weight: bold; margin-bottom: 10px;">轮播图管理</div>
            <image-upload v-model="bannerForm.banner_url" style="margin-bottom: 10px;" />
            <el-input v-model="bannerForm.banner_title" placeholder="请输入轮播图标题" style="margin-bottom: 10px; width: 300px;" />
            <el-input v-model="bannerForm.redirect_url" placeholder="请输入跳转链接" style="margin-bottom: 10px; width: 300px;" />
            <el-button type="primary" @click="submitBanner">新增轮播图</el-button>
          </el-card>
          <!-- 轮播图列表 -->
          <el-table :data="bannerList" border style="width: 100%">
            <el-table-column prop="banner_url" label="图片" width="180">
              <template #default="scope">
                <img :src="scope.row.banner_url" alt="banner" style="width: 120px; height: 60px; object-fit: cover;" />
              </template>
            </el-table-column>
            <el-table-column prop="banner_title" label="标题" width="180" />
            <el-table-column prop="redirect_url" label="跳转链接" />
            <el-table-column label="操作" width="180">
              <template #default="scope">
                <el-button size="mini" @click="handleEditBanner(scope.row)">编辑</el-button>
                <el-button size="mini" type="danger" @click="handleDeleteBanner(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <!-- 编辑轮播图弹窗 -->
          <el-dialog :title="'编辑轮播图'" :visible.sync="editBannerDialog" width="500px">
            <el-form :model="editBannerForm" label-width="80px">
              <el-form-item label="图片">
                <image-upload v-model="editBannerForm.banner_url" />
              </el-form-item>
              <el-form-item label="标题">
                <el-input v-model="editBannerForm.banner_title" />
              </el-form-item>
              <el-form-item label="跳转链接">
                <el-input v-model="editBannerForm.redirect_url" />
              </el-form-item>
            </el-form>
            <template #footer>
              <el-button @click="editBannerDialog = false">取 消</el-button>
              <el-button type="primary" @click="submitEditBanner">保 存</el-button>
            </template>
          </el-dialog>
        </el-tab-pane>
        <el-tab-pane label="介绍信息" name="introduction">
          <el-table :data="introductionData" border style="width: 100%">
            <el-table-column prop="key" label="标题" width="180"></el-table-column>
            <el-table-column prop="value" label="内容"></el-table-column>
            <el-table-column label="操作" width="150">
              <template #default="scope">
                <el-button type="text" @click="handleEdit(scope.row)">编辑</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </el-card>

    <!-- 编辑对话框 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="500px"
      :append-to-body="true"
    >
      <el-form :model="editForm" :rules="rules" ref="editForm" label-width="80px">
        <el-form-item label="标题" prop="key">
          <el-input v-model="editForm.key" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="内容" prop="value">
          <el-input type="textarea" v-model="editForm.value" :rows="4"></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="handleSave" :loading="loading">确 定</el-button>
        </div>
      </template>
    </el-dialog>

  </div>
</template>

<script>
import { getConfig, updateConfig } from '@/api/config'
import ImageUpload from '@/components/ImageUpload.vue'
import { addBanner, getBannerList, updateBanner, deleteBanner } from '@/api/banner'

export default {
  name: 'AdminConfig',
  components: {
    ImageUpload
  },
  data() {
    return {
      activeTab: 'strength',
      strengthData: [],
      introductionData: [],
      dialogVisible: false,
      dialogTitle: '',
      loading: false,
      editForm: {
        key: '',
        value: ''
      },
      rules: {
        value: [
          { required: true, message: '请输入内容', trigger: 'blur' }
        ]
      },
      testDialog: false,
      bannerForm: {
        banner_url: '',
        banner_title: '',
        redirect_url: ''
      },
      // 轮播图管理
      bannerList: [],
      editBannerDialog: false,
      editBannerForm: {
        id: '',
        banner_url: '',
        banner_title: '',
        redirect_url: ''
      }
    }
  },
  created() {
    this.fetchData()
    this.fetchBannerList()
  },
  methods: {
    async fetchData() {
      try {
        const [strengthData, introductionData] = await Promise.all([
          getConfig('STRENGTH_NUMBERS'),
          getConfig('INTRODUCTION')
        ])

        this.strengthData = strengthData
        this.introductionData = introductionData
      } catch (error) {
        console.error('获取配置数据失败:', error)
        this.$message.error('获取配置数据失败')
      }
    },
    handleEdit(row) {
      console.log('edit', row)
      this.editForm = { ...row }
      this.dialogTitle = '编辑配置'
      this.dialogVisible = true
      console.log('dialogVisible:', this.dialogVisible)
    },
    async handleSave() {
      try {
        if (this.activeTab === 'strength') {
          // 编辑的是 strengthData
          const idx = this.strengthData.findIndex(item => item.key === this.editForm.key)
          if (idx !== -1) {
            this.strengthData[idx].value = this.editForm.value
          }
          const params = {
            type: 'STRENGTH_NUMBERS',
            list: this.strengthData
          }
          await updateConfig(params)
        } else if (this.activeTab === 'introduction') {
          // 编辑的是 introductionData
          const idx = this.introductionData.findIndex(item => item.key === this.editForm.key)
          if (idx !== -1) {
            this.introductionData[idx].value = this.editForm.value
          }
          const params = {
            type: 'INTRODUCTION',
            list: this.introductionData
          }
          await updateConfig(params)
        }

        this.$message.success('保存成功')
        this.dialogVisible = false
        this.fetchData()
      } catch (error) {
        this.$message.error('保存失败，请重试')
      }
    },
    async submitBanner() {
      if (!this.bannerForm.banner_url) {
        this.$message.error('请先上传图片')
        return
      }
      if (!this.bannerForm.banner_title) {
        this.$message.error('请输入标题')
        return
      }
      try {
        await addBanner(this.bannerForm)
        this.$message.success('新增轮播图成功')
        this.bannerForm = { banner_url: '', banner_title: '', redirect_url: '' }
        this.fetchBannerList()
      } catch (e) {
        this.$message.error('新增失败')
      }
    },
    // 获取轮播图列表
    async fetchBannerList() {
      try {
        const res = await getBannerList()
        this.bannerList = Array.isArray(res) ? res : []
      } catch (e) {
        this.bannerList = []
      }
    },
    // 编辑轮播图
    handleEditBanner(row) {
      this.editBannerForm = { ...row }
      this.editBannerDialog = true
    },
    async submitEditBanner() {
      if (!this.editBannerForm.banner_url || !this.editBannerForm.banner_title) {
        this.$message.error('请填写完整信息')
        return
      }
      try {
        await updateBanner(this.editBannerForm.id, this.editBannerForm)
        this.$message.success('保存成功')
        this.editBannerDialog = false
        this.fetchBannerList()
      } catch (e) {
        this.$message.error('保存失败')
      }
    },
    // 删除轮播图
    async handleDeleteBanner(row) {
      this.$confirm('确定要删除该轮播图吗？', '提示', { type: 'warning' })
        .then(async () => {
          await deleteBanner(row.id)
          this.$message.success('删除成功')
          this.fetchBannerList()
        })
        .catch(() => {})
    }
  }
}
</script>

<style scoped>
.config-container {
  padding: 20px;
}
</style> 